import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const ETTResistanceUI = (props: UIProperties<ETTResistanceUIConfig>) => {
	const [selectionIndx, setSelectionIndx] = useState(0);
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '800px',
				height: '640px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '100%',
					height: '65px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '13px'
					}} className="title-font">Inserting ETT</p>
				</div>
				<div style={{
					width: '100%',
					height: '570px',
					position: 'absolute',
					top: '70px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					<div style={{
						position: 'absolute',
						top: '11px',
						left: '0',
						width: '100%',
						height: '65px',
					}}>
						<p style={{
							margin: '0px',
							fontSize: '25pt',
							textAlign: 'center',
							position: 'relative',
							top: '13px',
							marginLeft: '40px',
							marginRight: '40px',
							marginTop: '40px',
							marginBottom: '40px'
						}} className="title-font">THERE IS RESISTANCE</p>
						<p style={{
							margin: '0px',
							fontSize: '20pt',
							textAlign: 'center',
							position: 'relative',
							top: '13px',
							fontWeight: 'normal'
						}} className="title-font">What would you like to do?</p>
					</div>
					<CustomButton 
						showYellowThingyOnTheSide={selectionIndx === 0}
						text='Manipulate Larynx'
						position= {{
							type: 'absolute', 
							top: '237px',
							left: '30px'
						}}
						onClicked={() => {
							setSelectionIndx(0);
						}}/>
					<CustomButton 
						showYellowThingyOnTheSide={selectionIndx === 1}
						text='Rotate Tube'
						position= {{
							type: 'absolute', 
							top: '237px',
							left: '275px'
						}}
						onClicked={() => {
							setSelectionIndx(1);
						}}/>
					<CustomButton 
						showYellowThingyOnTheSide={selectionIndx === 2}
						text='Abort Attempt And Choose Another technique'
						position= {{
							type: 'absolute', 
							top: '237px',
							left: '520px'
						}}
						onClicked={() => {
							setSelectionIndx(2);
						}}/>
					<GeneralButtonWithText parameters= {{
						text: 'Next',
						top: '450px',
						left: '310px',
						width: '200px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						onClicked: () => {
							props.parameters.onNextClicked(selectionIndx);
						}
					}}/>
					
				</div>
				
			</div>
		</div>
	);

};

const CustomButton = (props: CustomButtonConfig) => {
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: '200px',
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					top: '0px',
					left: '0px',
					isDisabled: false,
					width: '200px',
					srcIdle: './assets/images/general/buttons/button_side_large-1.png',
					srcHighlight: null,
					srcDisabled: './assets/images/general/buttons/button_side_large-1.png',
					customButtonStyle: {
						width: '200px'
					},
					customImgStyle: {
						width: '100%'
					},
					customMainStyle: {
						// position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					onClicked: () => {
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				
				<div style={{
					position: 'relative',
					height: '144px',
					pointerEvents: 'none',
					width: '80%',
					left: '50%',
					top: '0',
					transform: 'translate(-50%, 0)'
				}}>
					<div style={{
						position: 'relative',
						top: '50%',
						transform: 'translate(0, -50%)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '16pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
					
				</div>

				{props.showYellowThingyOnTheSide ? (
					<img style={{
						position: 'absolute',
						top: 0,
						right: '-35px',
						width: '41px',
						pointerEvents: 'none'
					}} src="./assets/images/general/buttons/button_side_pointer.png" />
				) : (null)}
			</div>
		</div>
	);

};

interface CustomButtonConfig {
	text: string;
	position: CustomButtonPosition;
	showYellowThingyOnTheSide?: boolean;
	onClicked: () => void;
}

interface CustomButtonPosition {
	type?: any;
	left: string;
	top: string;
}

export interface ETTResistanceUIConfig extends BaseConfig{
	show: () => boolean;
	onNextClicked: (selectionIndex: number) => void;
}

export default ETTResistanceUI;